import Service from "@/helpers/py-service";

const state = {
  isLoading: false,
  calcsList: [],
  meta: {},
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_CALCS(state, calcsList) {
    state.calcsList = calcsList;
  },
  SET_LOADING_LIST(state, value) {
    state.isLoading = value;
  },
};

const actions = {
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING_LIST", value);
  },
  list: (store, params) => {
    store.state.isLoading = true;
    return Service.get(`flespi/flespi-calcs`, params)
      .then((data) => {
        store.commit("SET_CALCS", data.body.data);
        store.commit("SET_META", data.body);
      })
      .finally(() => (store.state.isLoading = false));
  },

  calcSync: (store, params) => {
    store.state.isLoading = true;
    return Service.get(`flespi/flespi-calcs/sync`, params)
      .then(() => {
        store.dispatch("list");
      })
      .finally(() => (store.state.isLoading = false));
  },
  bulkAssign: (store, params) => {
    store.state.isLoading = true;
    return Service.post(`flespi/assign-flespi-calculators-to-tenant`, params)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.isLoading = false));
  },
};

const getters = {
  getMeta(state) {
    return state.meta;
  },
  getCalcsList(state) {
    return state.calcsList;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

const flespiCalculators = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default flespiCalculators;
